<template>
    <div class="fhw">
        <div ref="rv_life_garage_mfe" class="fhw"></div>
    </div>
</template>

<script>
import {handleMFEMessages} from "../utils/messages";
import {handleMFENavigation, MFE_BASE_PATH, MFES, navigate} from "../utils/navigation";
import {EVENTS} from "../utils/events";
import {handleUnauthenticatedAPICall} from "../utils/api";
import {getDynamicScript} from "../utils/dynamic";


export default {
    name: "Garage",
    methods: {
        async mountMFE() {
            this.$root.$emit(EVENTS.PROCESSING);
            await this.module?.mount(this.$refs.rv_life_garage_mfe, {
                initialHistory: this.initialHistory,
                "slug": this.getVueEnv('SSO_CLIENT_SLUG'),
            });
            this.$root.$emit(EVENTS.READY);
        },
        close() {
            navigate(`${MFE_BASE_PATH[MFES.SETTINGS]}/settings`);
        },
    },
    async mounted() {
        const {ready, error, module} = await getDynamicScript({
            url: `${this.getVueEnv('RVLIFE_GARAGE_REMOTE_URL')}/remoteEntry.js`,
            scope: 'rv_life_garage',
            module: './RVLifeGarageApp'
        });

        if (ready) {
            this.module = module;
        } else {
            throw new Error(error);
        }

        if (!this.dataStore.user) {
            await navigate(MFE_BASE_PATH[MFES.AUTH]);
            return;
        }

        await this.mountMFE();

        const listener = (event) => {
            switch (event?.detail?.type) {
                case 'close':
                    this.close();
                    break;
                case 'message':
                    handleMFEMessages(event?.detail?.payload, 'rv_life_garage')
                    break;
                case 'navigate':
                    handleMFENavigation(event?.detail?.extra, MFES.GARAGE);
                    break;
                case 'error':
                    handleUnauthenticatedAPICall(event, 'rv_life_garage');
                    break;
                default:
                    break;
            }
        };

        const popStateListener = (event) => {
            if (event.state) {
                // The user clicked the back or forward button
                this.mountMFE();
            }
        }

        document.addEventListener('rvlife_garage', listener);
        window.addEventListener('popstate', popStateListener);
        this.$once('hook:beforeDestroy', () => {
            document.removeEventListener('rvlife_garage', listener);
            window.removeEventListener('popstate', popStateListener);
        })
    },
    data() {
        return {
            module: null
        }
    },
    computed: {
        initialHistory() {
            let page = this.$route.params.page;

            return [page ? `/${page}` : '/']
        }
    }
}
</script>

<style scoped lang="scss">
.fhw {
    height: 100%;
    width: 100%;
}
</style>